export enum SDKs {
  // Original SDKs
  LOCAL_CONTENT = "local-content",
  LOCAL_CONTENT_GOOGLE_MAPS = "local-content-google-maps",
  DEMOGRAPHICS = "demographics",

  // Local Profiles EVE SDK
  LOCAL_PROFILES = "local-profiles",

  // Local Profiles V2 SDKs
  LOCAL_NEIGHBORHOOD_HERO = "local-neighborhood-hero",
  LOCAL_NEIGHBOURHOOD_MAP = "local-neighbourhood-map",
  LOCAL_NEIGHBOURHOOD_MAP_GOOGLE_MAPS = "local-neighbourhood-map-google-maps",
  LOCAL_NEIGHBORHOOD_CHARACTERISTICS = "local-neighborhood-characteristics",
  LOCAL_NEIGHBORHOOD_HIGHLIGHTS = "local-neighborhood-highlights",
  LOCAL_NEIGHBORHOOD_DEMOGRAPHICS = "local-neighborhood-demographics",
}
